import { usePlaylist } from 'Playlists';
import { useContentProgress } from 'ContentProgress';
import { useCurrentUser } from 'FrontRoyalAngular';
import { type Stream } from 'Lessons';
import { useCallback } from 'react';
import { useBookmarkedStreams, useLaunchableStreams } from 'Streams';
import { getActivePlaylistLocalePackId } from 'Users';

export const useNextUpStream = () => {
    const currentUser = useCurrentUser();
    const { streamProgressByLocalePackId } = useContentProgress();
    const activePlaylistLocalePackId = getActivePlaylistLocalePackId(currentUser);
    const activePlaylist = usePlaylist(activePlaylistLocalePackId ?? '');
    const bookmarkedStreams = useBookmarkedStreams();
    const playlistStreams = useLaunchableStreams(activePlaylist?.streamEntries.map(entry => entry.localePackId) ?? []);

    const isIncompleteStream = useCallback(
        (s: Stream) => !streamProgressByLocalePackId[s.localePack.id]?.complete,
        [streamProgressByLocalePackId],
    );

    const nextStreamInPlaylist = playlistStreams.find(isIncompleteStream);
    const nextStreamInBookmarkedStreams = bookmarkedStreams.find(isIncompleteStream);

    return {
        nextStreamInPlaylist,
        nextStreamInBookmarkedStreams,
        nextUpStream: nextStreamInPlaylist ?? nextStreamInBookmarkedStreams,
    };
};
